export default "__VITE_ASSET__5c3ad65a__"